
export default {
  investors: []
}
